import usePrivateAxios from '@/common/api/usePrivateAxios';
import { ErrorResponse } from '@/common/types/errorResponse';
import { useMutation } from '@tanstack/react-query';

interface UseBillingBillRemoveFailureProps {
  billId?: string;
  onSuccess?: (response: any) => void;
  onError?: (response: ErrorResponse) => void;
}

export const useBillingBillRemoveFailure = ({ billId, onSuccess, onError }: UseBillingBillRemoveFailureProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['billingBillRemoveFailure', billId],
    mutationFn: () => privateAxios.put(`/billing/bills/${billId}/remove_failure`),
    onSuccess,
    onError,
  });
};
